<template>
	<section>
		<header-page
			name="resources"
			:title="$route.meta.title"
		/>
		<v-layout wrap pa-5>
			<v-flex xs5 pr-4>
				<v-layout wrap>
					<v-flex xs12 pb-4>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Nombre"
							required
							v-model="$v.model.name.$model"
							:error="$v.model.name.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-4>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Título"
							required
							v-model="$v.model.title.$model"
							:error="$v.model.title.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-4>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="URL WEB"
							required
							v-model="$v.model.uri.$model"
							:error="$v.model.uri.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-4>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							type="Number"
							label="Fragmento móvil"
							required
							v-model="$v.model.numFragment.$model"
							:error="$v.model.numFragment.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-4>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Controlador"
							required
							v-model="$v.model.controller.$model"
							:error="$v.model.controller.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-4>
						<v-textarea
							background-color="white"
							box
							class="body-1"
							height="80"
							hide-details
							label="Descripción"
							no-resize
							required
							v-model="$v.model.description.$model"
							:error="$v.model.description.$error"
						>
						</v-textarea>
					</v-flex>
					<v-flex xs12 pb-4>						
						<v-layout wrap align-center>
							<v-text-field
								solo
								class="body-1 mx-2 mt-0"
								height="30px"
								hide-details
								required
								label="Icono"
								v-model="$v.model.pathIcon.$model"
								:error="$v.model.pathIcon.$error"
							>
							</v-text-field>
							<upload-image 
								label-ref="up"
								label-for="image"
								input-id="image"
								@send-image="getImage"
							/>
						</v-layout>
					</v-flex>
					<v-flex xs12 pb-4>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Link de video"
							v-model="model.link"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 mb-5>
						<v-layout wrap row justify-space-between>
							<v-flex xs5>
								<label class="body-2">Agregar etiqueta</label>
							</v-flex>
							<v-flex xs2>
								<v-switch
									class="mt-0"
									color="base"
									hide-details
									:label="flagNewName"
									v-model="model.flagNew"
								/>
							</v-flex>
							<v-flex xs12 caption>
								<span>Se mostrará junto al nombre del recurso (Ej.: Nuevo, Beta, etc...)</span>
							</v-flex>
						</v-layout>
						<v-layout v-if="model.flagNew" row wrap>
							<v-flex
								xs12
								v-for="(language, lanKey) in languagesByProject"
								:key="lanKey"
							>
								<label>{{ language.name }}:</label>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									required
									v-model="model.newTitle[lanKey].title"
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs7 pl-3>
				<v-layout wrap>
					<v-flex xs12 pb-3>
						<label class="title-form pl-2">WEB SERVICE</label>
						<v-divider></v-divider>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-layout wrap>
							<v-flex xs5 pr-3>
								<v-select
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Dominio"
									item-text="name"
									item-value="code"
									:items="domains"
									v-model="paramsService.domain"
								></v-select>
							</v-flex>
							<v-flex xs3 pr-3>
								<v-select
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Método"
									item-text="name"
									item-value="code"
									:items="methods"
									v-model="paramsService.method"
								></v-select>
							</v-flex>
							<v-flex xs4>
								<v-layout>
									<v-flex xs9>
										<v-text-field
											background-color="white"
											box
											class="body-1"
											hide-details
											label="Nombre"
											v-model="paramsService.path"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs3>
										<button 
											class="btn-search"
											@click="openSearch">
											<img 
												src="https://goo.su/BNGK94J" 
												alt="Buscar"
												height="20">
									</button>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12>
						<resource-list
							:rows="rows"
							@edit-service="editService"
							@delete-service="openDialog"
						/>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="$v.$invalid || loading"
				:on-run-service="loading"
				@accept-button-clicked="createResource"
				@cancel-button-clicked="cancelCreateResource"
			/>
		</section>
		<action-sidebar
			:title="action.title"
			:value="action.value"
			:width="action.width"
			@close-modal="closeModal"
		>
			<resource-search 
				v-if="action.code === 'resource-search'"
				:code-project="codeProject"
				:params-service="paramsService"
				@add-service="addService"
				/>
			<service-edit 
				v-if="action.code === 'edit-service'"
				:domains="domains"
				:methods="methods"
				:service="dataEditService"
				@save-edit-service="saveEditService"
				@close="closeModal"
			/>	
		</action-sidebar>
		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-card-title class="subheading">{{ dialogMessage }}</v-card-title>
				<v-card-actions class="justify-center">
					<v-btn
						class="btn-action"
						color="green"
						dark
						@click.native="deleteService"
					>
						SI
					</v-btn>
					<v-btn
						class="btn-action"
						color="error"
						dark
						@click.native="closeDialog"
					>
						NO
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import { required, requiredIf, numeric } from 'vuelidate/lib/validators';
import actionSidebar from '@/components/shared/action-sidebar';
import helper from '@/shared/helper';
import resourceList from '@/components/resource-service/resource-list';
import resourceSearch from '@/components/resource-service/resource-search';
import serviceEdit from '@/components/resource-service/service-edit';
import UploadImage from '@/components/shared/upload-image';

const { getLocalData } = helper;

function openSearch() {
	this.action.title = 'Web Service';
	this.action.code = 'resource-search';
	this.action.width = 700;
	this.action.value = true;
}

function closeModal() {
	this.action.title = '';
	this.action.code = null;
	this.action.value = false;
	this.paramsService = { ...this.paramsServiceDefault };
	this.dataEditService = {};
}

function editService(row) {
	this.dataEditService = { ...row };
	this.action.width = 500;
	this.action.title = 'Editar';
	this.action.code = 'edit-service';
	this.action.value = true;
}

async function loadData() {
	const requests = [
		this.$http.get(`projects/${this.codeProject}/domains`),
	];
	if (this.id) {
		requests.push(await this.$http.get(`resource/${this.id}`));
	}
	try {
		const responses = await Promise.all(requests);
		const [domains] = responses;
		this.domains = domains.data || [];
		if (this.id) {
			this.loadServices();
			const [, { data: modelResponse }] = responses;
			const { data: modelData } = modelResponse;
			if (modelData.flagNew && !modelData.newTitle) {
				const newTitleKeys = Object.keys(this.newTitle);
				newTitleKeys.forEach((k) => {
					const text = k === 'es' ? 'Nuevo' : 'New';
					const kTitle = { title: text };
					this.$set(this.newTitle, k, kTitle);
				});
				modelData.newTitle = { ...this.newTitle };
			}
			this.model = { ...modelData };
			this.model.newTitle = modelData.newTitle || { ...this.newTitle };
			this.model.moduleId = this.moduleId;
			this.model.services = this.model.services || [];
			this.rows = this.model.services || [];
			delete this.model.module;
		} else {
			this.model.newTitle = { ...this.newTitle };
		}
	} catch (error) {
		this.showError();
	}
}

function getImage({ urlImage }) {
	this.model.pathIcon = urlImage;
}

function flagNewName() {
	return this.model.flagNew ? 'Sí' : 'No';
}

function addService(row) {
	const index = this.rows.findIndex(r => r.id === row.id);
	if (index > -1) {
		this.showNotification('El servicio ya fue agregado a la lista', 'info');
	} else {
		this.rows.push(row);
		this.paramsService = { ...this.paramsServiceDefault };
		this.closeModal();
	}
}

function deleteService() {
	const index = this.rows.findIndex(r => r.id === this.dataEditService.id);
	if (index > -1) {
		this.rows.splice(index, 1);
		this.showNotification('El servicio ya fue eliminado a la lista', 'info');
		this.closeDialog();
	}
}

function cancelCreateResource() {
	this.goTo('page-resource');
}

async function createResource() {
	this.model.services = this.rows.map((r) => {
		const newService = {};
		newService.id = r.id;
		newService.authorize = r.flagAuth;
		return newService;
	});
	const method = this.id ? 'put' : 'post';
	const url = this.id ? `resource/${this.id}` : 'resource';
	const message = this.id ? 'editado' : 'creado';
	this.loading = true;
	try {
		await this.$http[method](url, this.model);
		this.showNotification(`Recurso ${message} correctamente.`);
		this.goTo('page-resource');
	} catch (err) {
		this.showError();
	} finally {
		this.loading = false;
	}
}

function saveEditService(row) {
	const newRows = [...this.rows];
	const index = newRows.findIndex(r => r.id === row.id);
	if (index > -1) {
		newRows[index] = { ...row };
		this.rows = [...newRows];
		this.closeModal();
	}
}

async function loadServices() {
	try {
		const { data: response } = await this.$http.get(`resources/${this.id}/services`);
		this.rows = response.data.map((r) => {
			const newRow = { ...r };
			newRow.flagAuth = r.authorize;
			return newRow;
		});
	} catch (error) {
		this.showError();
	}
}

function openDialog(row) {
	this.dataEditService = { ...row };
	this.dialog = true;
	this.dialogMessage = `Desear eliminar ${row.name} de la lista de servicios del recurso`;
}

function closeDialog() {
	this.dataEditService = {};
	this.dialog = false;
	this.dialogMessage = '';
}

function validations() {
	const validation = {
		model: {
			controller: { required },
			description: { required },
			name: { required },
			newTitle: { required: requiredIf(() => !!this.model.flagNew) },
			numFragment: { required, numeric },
			pathIcon: { required },
			title: { required },
			uri: { required },
		},
	};
	return validation;
}

function created() {
	this.languagesByProject = getLocalData('project-languages');
	const languagesKeys = Object.keys(this.languagesByProject);
	this.newTitle = languagesKeys.reduce((a, k) => {
		const newA = { ...a };
		newA[k] = { title: '' };
		return newA;
	}, {});
	this.loadData();
}

function data() {
	return {
		action: {
			code: null,
			title: '',
			value: false,
			width: 524,
		},
		domains: [],
		loading: false,
		methods: [
			{ code: 'get', name: 'GET' },
			{ code: 'post', name: 'POST' },
			{ code: 'delete', name: 'DELETE' },
			{ code: 'patch', name: 'PATCH' },
		],
		languagesByProject: {},
		model: {
			action: ['GET'],
			controller: '',
			description: '',
			flagNew: false,
			link: '',
			moduleId: this.moduleId,
			name: '',
			newTitle: {},
			numFragment: '',
			pathIcon: '',
			position: 1,
			services: [],
			title: '',
			uri: '',
		},
		paramsService: {
			codeProject: this.codeProject,
			method: null,
			path: null,
			domain: null,
		},
		paramsServiceDefault: {
			codeProject: this.codeProject,
			method: null,
			path: null,
			domain: null,
		},
		rows: [],
		dataEditService: {},
		dialog: false,
		dialogMessage: '',
		newTitle: {},
	};
}

export default {
	name: 'page-resource-new-update',
	data,
	created,
	components: {
		actionSidebar,
		UploadImage,
		resourceList,
		resourceSearch,
		serviceEdit,
	},
	computed: {
		flagNewName,
	},
	methods: {
		closeModal,
		editService,
		openSearch,
		loadData,
		getImage,
		addService,
		deleteService,
		cancelCreateResource,
		createResource,
		saveEditService,
		loadServices,
		openDialog,
		closeDialog,
	},
	props: {
		moduleId: {
			type: [String, Number],
			required: true,
		},
		moduleName: {
			type: String,
			required: true,
		},
		id: {
			type: [Number, String],
		},
		codeApp: {
			type: [String, Number],
		},
		codeProject: {
			type: [String, Number],
		},
	},
	validations,
};
</script>
<style lang="scss" scoped>
	.btn-search {
		background-color: map-get($colors, primary) !important;
		border-radius: 0px 5px 5px 0;
		height: 100%;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/resources/page-resource-new-update.vue